var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccreditationTick({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.992,
    height: 30.992,
    viewBox: "0 0 30.992 30.992",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8144",
    "data-name": "Rectangle 8144",
    width: 10.118,
    height: 8.864,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15579",
    "data-name": "Group 15579",
    transform: "translate(-548 -421.136)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    cx: 10.957,
    cy: 10.957,
    r: 10.957,
    transform: "translate(548 436.632) rotate(-45)",
    fill: "#3acb27"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15537",
    "data-name": "Group 15537",
    transform: "translate(558.437 432.2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15536",
    "data-name": "Group 15536",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5366",
    "data-name": "Path 5366",
    d: "M9.839,1.965,4.374,8.53A.868.868,0,0,1,3,8.53L.278,5.254a1.353,1.353,0,0,1,0-1.645.868.868,0,0,1,1.369,0L3.7,6.077,8.481.334a.868.868,0,0,1,1.369,0,1.35,1.35,0,0,1-.012,1.631",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccreditationTick);
export default __webpack_public_path__ + "static/media/accreditation-tick.16e1f5c520e89b2d01ebb333bd13fdd0.svg";
export { ForwardRef as ReactComponent };